<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-row class="ma-0">
    <div v-if="hasItems" class="col-5">
    <v-col v-if="isDisplayed('SALARIE_IDENTITE_ABSTRACT')" class="section_salarie_identite_abstract">
      <div>
        <slot name="section-salarie-identite-abstract">
          <section-salarie-identite-abstract ref="SALARIE_IDENTITE_ABSTRACT"
                                             id="SALARIE_IDENTITE_ABSTRACT"
                                             :extended="isExtended('SALARIE_IDENTITE_ABSTRACT')"
                                             :showButton="true"
                                             :autoSave="true"
                                             :readOnly="readOnly"
                                             :moduleId="moduleId"
                                             :searchText="searchText"
                                             :ressourceHeader="ressource"
                                             :fiche="fiche"
                                             :salarie=selectedSalarie
                                             :route="route"
                                             :attribut="attribut"
                                             @extended="setExtended"
                                             @fullscreen="setFullscreen"
                                             @status="updateStatus"
                                             @openSection="openSection"
                                             @updated="salarieUpdated"
                                             @selectItem = "selectItem">
          </section-salarie-identite-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_COORDONNEES_ABSTRACT')" class="section_salarie_coordonnees_abstract">
      <div>
        <slot name="section-salarie-coordonnees-abstract">
          <section-salarie-coordonnees-abstract ref="SALARIE_COORDONNEES_ABSTRACT"
                                                id="SALARIE_COORDONNEES_ABSTRACT"
                                                :extended="isExtended('SALARIE_COORDONNEES_ABSTRACT')"
                                                :showButton="true"
                                                :autoSave="true"
                                                :readOnly="readOnly"
                                                :moduleId="moduleId"
                                                :searchText="searchText"
                                                :ressourceHeader="ressource"
                                                :fiche="fiche"
                                                :salarie=selectedSalarie
                                                :adresse=selectedAdresse
                                                :route="route"
                                                :attribut="attribut"
                                                @extended="setExtended"
                                                @fullscreen="setFullscreen"
                                                @status="updateStatus"
                                                @openSection="openSection"
                                                @updated="salarieUpdated"
                                                @selectItem = "selectItem">
          </section-salarie-coordonnees-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT')" class="section_salarie_info_complementaires_abstract">
      <div>
        <slot name="section-salarie-info-complementaires-abstract">
          <section-salarie-info-complementaires-abstract ref="SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT"
                                                         id="SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT"
                                                         :extended="isExtended('SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT')"
                                                         :showButton="true"
                                                         :autoSave="true"
                                                         :readOnly="readOnly"
                                                         :moduleId="moduleId"
                                                         :searchText="searchText"
                                                         :ressourceHeader="ressource"
                                                         :fiche="fiche"
                                                         :salarie=selectedSalarie
                                                         :route="route"
                                                         :attribut="attribut"
                                                         @extended="setExtended"
                                                         @fullscreen="setFullscreen"
                                                         @status="updateStatus"
                                                         @openSection="openSection"
                                                         @updated="salarieUpdated"
                                                         @selectItem = "selectItem">
          </section-salarie-info-complementaires-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_ETAT_CIVIL_ABSTRACT')" class="section_salarie_etat_civil_abstract">
      <div>
        <slot name="section-salarie-etat-civil-abstract">
          <section-salarie-etat-civil-abstract ref="SALARIE_ETAT_CIVIL_ABSTRACT"
                                               id="SALARIE_ETAT_CIVIL_ABSTRACT"
                                               :extended="isExtended('SALARIE_ETAT_CIVIL_ABSTRACT')"
                                               :showButton="true"
                                               :autoSave="true"
                                               :readOnly="readOnly"
                                               :moduleId="moduleId"
                                               :searchText="searchText"
                                               :ressourceHeader="ressource"
                                               :fiche="fiche"
                                               :salarie=selectedSalarie
                                               :route="route"
                                               :attribut="attribut"
                                               @extended="setExtended"
                                               @fullscreen="setFullscreen"
                                               @status="updateStatus"
                                               @openSection="openSection"
                                               @updated="salarieUpdated"
                                               @selectItem = "selectItem">
          </section-salarie-etat-civil-abstract>
        </slot>
      </div>
    </v-col>
    <v-col v-if="isDisplayed('SALARIE_RIB_ABSTRACT')" class="section_salarie_rib_abstract">
      <div>
        <slot name="section-salarie-rib-abstract">
          <section-salarie-rib-abstract ref="SALARIE_RIB_ABSTRACT"
                                        id="SALARIE_RIB_ABSTRACT"
                                        :extended="isExtended('SALARIE_RIB_ABSTRACT')"
                                        :showButton="true"
                                        :autoSave="true"
                                        :readOnly="readOnly"
                                        :moduleId="moduleId"
                                        :searchText="searchText"
                                        :ressourceHeader="ressource"
                                        :fiche="fiche"
                                        :rib=selectedRib
                                        :salarie=selectedSalarie
                                        :route="route"
                                        :attribut="attribut"
                                        @extended="setExtended"
                                        @fullscreen="setFullscreen"
                                        @status="updateStatus"
                                        @openSection="openSection"
                                        @updated="salarieUpdated"
                                        @selectItem = "selectItem">
          </section-salarie-rib-abstract>
        </slot>
      </div>
    </v-col>
  </div>
      <v-col cols="6" v-if="!hasItems" class="empty-list-container">
        <img src="@/assets/SVG/empty-list.svg" class="empty-list-logo"/>
        <div class="empty-list-label">{{ getNewLabel() }}</div>
        <div class="pt-3" v-if="canAdd">
          <v-btn class="base"
                 :outlined="true"
                 :loading="false"
                 :block="true"
                 variant="flat"
                 @click="addItem">
            {{ addLabel }}
          </v-btn>
        </div>
      </v-col>
  </v-row>
  <Transition name="scrim">
    <div v-if="sectionOpen" class="global-scrim" @click="sectionOpen = false"></div>
  </Transition>

  <Transition name="slide-panel">
    <div v-if="sectionOpen" class="local-panel-wrap">
      <div class="local-panel col-5">
        <component :is="sectionComponent" ref="SECTION_DIALOG" v-bind="currentProperties" v-on="events"></component>
      </div>
    </div>
  </Transition>
  </div>
</template>
<script lang="ts">
import { markRaw, defineComponent,defineAsyncComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter, goToModule } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Salarie from '@/extend/classes/Salarie';
import Adresse from '@/extend/classes/Adresse';
import { storeAdresse } from '@/generated/stores';
import Rib from '@/extend/classes/Rib';
import { storeRib } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import {getSection} from "@/framework/base/helpers/ComponentFinder.ts";
import SectionSalarieIdentiteAbstract from '@/extend/sections/SectionSalarieIdentiteAbstractExtend.vue';
import SectionSalarieCoordonneesAbstract from '@/extend/sections/SectionSalarieCoordonneesAbstractExtend.vue';
import SectionSalarieInfoComplementairesAbstract from '@/extend/sections/SectionSalarieInfoComplementairesAbstractExtend.vue';
import SectionSalarieEtatCivilAbstract from '@/extend/sections/SectionSalarieEtatCivilAbstractExtend.vue';
import SectionSalarieRibAbstract from '@/extend/sections/SectionSalarieRibAbstractExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionSalarieIdentiteAbstract,
    SectionSalarieCoordonneesAbstract,
    SectionSalarieInfoComplementairesAbstract,
    SectionSalarieEtatCivilAbstract,
    SectionSalarieRibAbstract,
    FicheHeader,
  },

  props: {
    salarie: {
      type: Object as PropType<Salarie>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
    if (this.salarie && this.salarie.id < 0 && this.routeElement && this.routeElement.section.component ) {
      const route = new Route();
      const component = (this.routeElement?.section.component);
      this.$nextTick(() => {
        this.openSection(component, route, false);
      });
    }
  },

  data() {
    return {
      moduleId: 0,
      sectionOpen: false,
      sectionComponent: null,
      fiche: Fiches.SALARIE_ABSTRACT,
      sections: [
        'SALARIE_IDENTITE_ABSTRACT',
        'SALARIE_COORDONNEES_ABSTRACT',
        'SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT',
        'SALARIE_ETAT_CIVIL_ABSTRACT',
        'SALARIE_RIB_ABSTRACT',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_SALARIE_ABSTRACT);
    },

    hasItems (): boolean {
      return this.salarie.id > 0
    },

      canAdd() : boolean {
        return false;
      },

      addLabel() : string {
        return 'Ajouter';
      },

    selectedSalarie (): Salarie {
      return this.salarie
    },

    events (): Record<string, () => void> {
      const event: any = {};
      event["saved"] = () => this.sectionOpen = false;
      event["closeDialog"] = () => this.sectionOpen = false;
      return event;
    },

    currentProperties (): any {
      return {
        extended: true,
        showButton: true,
        autoSave:true,
        readOnly:this.readOnly,
        moduleId: this.moduleId,
        ressourceHeader:this.ressource,
        fiche: this.fiche,
        isAbstract: true,
        salarie: this.selectedSalarie,
        route:this.route,
        attribut: this.attribut,
        adresse: this.selectedAdresse,
        rib: this.selectedRib,
      };
    },

    selectedAdresse (): Adresse {
      if (this.salarie.adresseId == 0) {
        return storeAdresse.createNewAdresse();
      } else {
        return storeAdresse.getAdresse(this.salarie.adresseId);
      }
    },

    selectedRib (): Rib {
      if (this.salarie.ribId == 0) {
        return storeRib.createNewRib();
      } else {
        return storeRib.getRib(this.salarie.ribId);
      }
    },

  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    openSection (component: any, route: Route, isList = false): void {
      if (isList) {
        goToModule(this.router, route)
      } else {
         if (component) {
          this.sectionComponent = component;
          this.sectionOpen = true;
        };
      }
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    salarieUpdated (salarie: Salarie) {
    // To implement
    },

      addItem() : void {
        // To implement
      },

      getNewLabel() : string {
        return ""
      },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.salarie || this.salarie.id < 0) && value == 'SALARIE_IDENTITE_ABSTRACT') {
        this.setExtended(new Extended('SALARIE_IDENTITE_ABSTRACT', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
